import { all } from "redux-saga/effects";
import {
  watchCreateCourse,
  watchDeleteCourse,
  watchFetchAllCourses,
  watchFetchAllScormPackages,
  watchMount,
  watchUnmount,
} from "./watchers";

export function* coursesSagas() {
  yield all([
    watchCreateCourse(),
    watchDeleteCourse(),
    watchFetchAllCourses(),
    watchFetchAllScormPackages(),
    watchMount(),
    watchUnmount(),
  ]);
}
